import { faIcon } from "@utils/faIcon"
import formatQuantity from "@utils/formatQuantity"

import { Badge } from "@atoms"

import { QuantityOnOrderBadgeProps } from "./QuantityOnOrderBadge.types"

const icon = faIcon({ name: "truck", style: "regular" })

export default function QuantityOnOrderBadge(props: QuantityOnOrderBadgeProps) {
    const { count, size = "md" } = props

    // The badge is always shown — a missing count renders as "0".
    const total = formatQuantity(count ?? 0)

    return (
        <Badge size={size} variant="icon" icon={icon} tooltip={`On order\n${total}`}>
            {total}
        </Badge>
    )
}
